import React, { useState } from "react";
import { Link } from "react-router-dom";

const HomeShowcaseCard = ({ blog }) => {
  const [blogImage] = useState(blog.image["url"]);
  return (
    <>
      {/* loog here  */}
      <div className="p-4 md:w-1/3">
        <div className="h-full rounded-xl shadow-cla-blue bg-gradient-to-r from-indigo-50 to-blue-50 overflow-hidden">
          <img
            className="lg:h-48 md:h-36 w-full object-cover object-center scale-110 transition-all duration-400 hover:scale-100"
            src={blogImage}
            alt="blog"
          />
          <div className="p-6">
            <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">
              {blog.category}
            </h2>
            <Link
              to={`/blog-by-user/${blog.userId._id}`}
              className="tracking-widest text-xl title-font font-medium text-indigo-600 mb-1"
            >
              -{blog.userId.fullName}
            </Link>
            <h1 className="title-font text-lg font-medium text-gray-600 mb-3">
              {blog.title}
            </h1>
            <div className="flex items-center flex-wrap ">
              <Link
                to={`/blog-details/${blog._id}`}
                className="bg-gradient-to-r from-cyan-400 to-blue-400 hover:scale-105 drop-shadow-md  shadow-cla-blue px-4 py-1 rounded-lg"
              >
                Read more
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* loog here  */}
    </>
  );
};

export default HomeShowcaseCard;
